export const PolicyStatus = {
  issued: 'ISSUED',
  cancelled: 'CANCELLED',
  reinstate: 'REINSTATE',
}